import React, { useState, useEffect } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { AutoComplete } from "primereact/autocomplete";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
    createAPIEndpointCreditMReports,
    EndpointCreditMReports,
} from "../../../Services/ReportsAll/CreditManagementReports";
// import Loader from "../../../Components/Loader";
import { Calendar } from "primereact/calendar";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { Checkbox } from "primereact/checkbox";


const StatementOfAccounts = () => {
    const currentDate = new Date();
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const auth = storage.getLocal("user");
    const [custStatementOfAccountData, setCustStatementOfAccountData] =
        useState();
    const [filteredcustAccountData, setFilteredcustAccountData] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [supplierStatementOfAccountData, setSupplierStatementOfAccountData] =
        useState();
    const [filteredSupplierAccountData, setFilteredSupplierAccountData] =
        useState(null);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [reportType, setReportType] = useState("Summary");
    const [custType, setCustType] = useState("customer");
    const [fileType, setFileType] = useState("xlsx");
    const [printData, setPrintData] = useState([]);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [showdisable, setshowdisable] = useState(false); //added on 12th may
    const [checked, setChecked] = useState(false);
    const fileTypes = [
        { label: "XLSX", value: "xlsx" },
        { label: "PDf", value: "PDf" },
    ];

    const searchAccount = (event) => {
        const query = event.query.toLowerCase();
        const filtered = custStatementOfAccountData?.filter(
            (account) =>
                account.PARTY_NAME.toLowerCase().includes(query) ||
                account.PARTY_CODE.toLowerCase().includes(query)
        );
        setFilteredcustAccountData(filtered);
    };
    const searchSupplier = (event) => {
        const query = event.query.toLowerCase();
        const filtered = supplierStatementOfAccountData?.filter(
            (supplier) =>
                supplier.SUPP_NAME.toLowerCase().includes(query) ||
                supplier.SUPP_CODE.toLowerCase().includes(query)
        );
        setFilteredSupplierAccountData(filtered);
    };

    const handleReportType = (e) => {
        setReportType(e.value);
        setSelectedCustomer(null);
        setSelectedSupplier(null);
    };

    const handleCustType = (e) => {
        setCustType(e.value);
        setSelectedCustomer(null);
        setSelectedSupplier(null);
    };

    // useEffect(()=>{
    //     setSelectedSupplier(null);
    //     setSelectedCustomer(null);
    // },[reportType,custType])

    const handleExportExcel = (data) => {
        let uniqueNo = `SOA_${reportType}_${checked ?"Expired_":""}${GetDateFormat()}`;

        try {
            if (data.length > 0) {
                if (reportType == "Detail") {
                    let wb = XLSX.utils.book_new();
                    //   downloadExcelDateFormat(data, uniqueNo);
                    let MapData = data.map((val) => {
                        let convfrmdt =
                            val["Date"] === "" || val["Date"] === null
                                ? ""
                                : new Date(val["Date"]?.replace(/(\d+[/])(\d+[/])/, "$2$1"));
                        let convenddt =
                            val["Due date"] === "" || val["Due date"] === null
                                ? ""
                                : new Date(
                                    val["Due date"]?.replace(/(\d+[/])(\d+[/])/, "$2$1")
                                );
                        let convenddt1 =
                            val["Reference Document Date"] === "" ||
                                val["Reference Document Date"] === null
                                ? ""
                                : new Date(
                                    val["Reference Document Date"]?.replace(
                                        /(\d+[/])(\d+[/])/,
                                        "$2$1"
                                    )
                                );
                        return {
                            ...val,
                            "Date": convfrmdt,
                            "Due date": convenddt,
                            "Reference Document Date": convenddt1,
                        };
                    });
                    let ws = XLSX.utils.json_to_sheet(MapData);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                } else {
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                }
            } else {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (err) {
            console.log("error ", err);
            toast.warning("unable to download", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
        setLoadingExcel(false);
    };

    const getCustStatementOfAccounts = async () => {
        setLoadingExcel(true);
        try {
            const response = await createAPIEndpointCreditMReports().get(
                `${EndpointCreditMReports.StatementOfAccountsGetCustomer}?CompId=${auth.CompId}`
            );
            if (response.data.length > 0) {
                const updatedData = response.data.map((item) => ({
                    ...item,
                    PARTY_NAME: `${item.PARTY_CODE} - ${item.PARTY_NAME}`,
                }));
                setCustStatementOfAccountData(updatedData);
            } else {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (err) {
            toast.error(`${err.response ? err.response.data : err.message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setLoadingExcel(false);
        }
    };

    const getSupplierStatementOfAccounts = async () => {
        setLoadingExcel(true);
        try {
            const response = await createAPIEndpointCreditMReports().get(
                `${EndpointCreditMReports.StatementOfAccountsGetSupplier}?CompId=${auth.CompId}`
            );
            if (response.data.length > 0) {
                const updatedData = response.data.map((item) => ({
                    ...item,
                    SUPP_NAME: `${item.SUPP_CODE} - ${item.SUPP_NAME}`,
                }));
                setSupplierStatementOfAccountData(updatedData);
            } else {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (err) {
            toast.error(`${err.response ? err.response.data : err.message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setLoadingExcel(false);
        }
    };

    const StatementOfAccountData = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");

        if (reportType == "Summary") {
            try {
                let res;
                setLoadingExcel(true);
                if (checked) {
                    res = await createAPIEndpointCreditMReports().get(
                        `${EndpointCreditMReports.StatementOfAccountsSummaryData}?CompId=${auth.CompId}&fromDate=${fromDateRange}&toDate=${toDateRange}&reportType=${reportType}&type=${custType}&expired=${true}`
                    );
                }
                else {
                    res = await createAPIEndpointCreditMReports().get(
                        `${EndpointCreditMReports.StatementOfAccountsSummaryData}?CompId=${auth.CompId}&fromDate=${fromDateRange}&toDate=${toDateRange}&reportType=${reportType}&type=${custType}&expired=${false}`
                    );
                }
                console.log("Dataa", res.data);

                if (fileType == "PDf") {
                    setPrintData(res.data);
                    setIsDataFetched(true);
                } else {
                    handleExportExcel(res.data);
                }
            } catch (error) {
                console.log(error);
                setLoadingExcel(false);
            }


        }
        if (reportType == "Detail") {
            if (custType == "customer" && selectedCustomer == null) {
                toast.error("Please select Customer", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }
            if (custType == "Supplier" && selectedSupplier == null) {
                toast.error("Please select Supplier", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                return;
            }
            setLoadingExcel(true);
            let id =
                custType == "customer"
                    ? selectedCustomer.MASK_PARTY_ID
                    : selectedSupplier.MASK_PARTY_ID;
            try {
                const res = await createAPIEndpointCreditMReports().get(
                    `${EndpointCreditMReports.StatementOfAccountsDetailsData}?CompId=${auth.CompId}&fromDate=${fromDateRange}&toDate=${toDateRange}&reportType=${reportType}&type=${custType}&custsuppId=${id}`
                );
                console.log("Dataa", res.data);

                if (fileType == "PDf") {
                    setPrintData(res.data);
                    setIsDataFetched(true);
                } else {
                    handleExportExcel(res.data);
                }
            } catch (error) {
                toast.error(error?.response?.data?.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            }
        }
    };

    useEffect(() => {
        if (isDataFetched) {
            setTimeout(() => {
                handleJsPdfExport();
                setIsDataFetched(false);
                setLoadingExcel(false);
            }, 100);
        }
    }, [isDataFetched]);


    const handleJsPdfExport = () => {
        const doc = new jsPDF("p", "pt", "a4");
        const margin = 40;
        let startY = margin;

        doc.setFontSize(12);
        doc.setFont("helvetica", "italic");
        doc.text(auth.CompLongName, margin, startY);
        startY += 20;
        doc.text(selectedCustomer?.PARTY_NAME.split(" - ")[1]?.trim(), margin, startY);
        startY += 15;
        doc.text("Report Name: Statement of Accounts Detail", margin, startY);
        startY += 15;
        doc.text(`Record Count: ${printData.length}`, margin, startY);
        startY += 15;
        doc.text(`From Date: ${format(new Date(fromDate), "dd/MM/yyyy")}`, margin, startY);
        startY += 15;
        doc.text(`To Date: ${format(new Date(toDate), "dd/MM/yyyy")}`, margin, startY);
        startY += 30;

        let columns = [];
        let body = [];

        if (reportType === "Detail") {
            columns = [
                "Document No.", "Document Date", "Document Type", "Due Date",
                "Reference Doc No.", "Reference Doc Date", "Mode", "Debit",
                "Credit", "Closing Balance", "Type"
            ];

            body = printData.map((row) => [
                row["Document No."] ?? "",
                row["Date"] ?? "",
                row["Document Type"] ?? "",
                row["Due date"] ?? "",
                row["Reference Document No."] ?? "",
                row["Reference Document Date"] ?? "",
                row["Mode"] ?? "",
                row["Debit Amount"] ?? 0,
                row["Credit Amount"] ?? 0,
                row["Closing Balance"] ?? 0,
                row["Type"] ?? ""
            ]);
        } else if (reportType === "Summary" && custType === "Supplier") {
            columns = [
                "Supplier Code", "Supplier Name", "Credit Limit", "Closing Balance",
                "Cheques in Hand", "Net Balance", "Debit or Credit"
            ];

            body = printData.map((row) => [
                row["Supplier Code"] ?? "",
                row["Supplier Name"] ?? "",
                row["Credit Limit"] ?? 0,
                row["Closing Balance"] ?? 0,
                row["Cheques in Hand"] ?? 0,
                row["Net Balance"] ?? 0,
                row["Debit or Credit"] ?? ""
            ]);
        } else if (reportType === "Summary" && custType === "customer") {
            columns = [
                "Customer Code", "Customer Name", "Credit Limit", "Closing Balance",
                "Cheques in Hand", "Net Balance", "Debit or Credit"
            ];

            body = printData.map((row) => [
                row["Customer Code"] ?? "",
                row["Customer Name"] ?? "",
                row["Credit Limit"] ?? 0,
                row["Closing Balance"] ?? 0,
                row["Cheques in Hand"] ?? 0,
                row["Net Balance"] ?? 0,
                row["Debit or Credit"] ?? ""
            ]);
        }

        autoTable(doc, {
            head: [columns],
            body,
            startY,
            margin: { left: margin, right: margin },
            styles: {
                fontSize: 7,
                lineColor: [0, 0, 0], // <-- set border color here (RGB)
                lineWidth: 0.1               // optional: controls border thickness
            },
            theme: "grid",
            headStyles: {
                fillColor: [224, 224, 224], // Light grey: #e0e0e0
                textColor: 0,
                fontStyle: "bold",
                halign: "center",
                lineColor: [0, 0, 0]  // <-- also apply to header borders (optional)
            },
            bodyStyles: {
                lineColor: [0, 0, 0]  // <-- apply to body rows
            },
            columnStyles: {
                7: { halign: "right" },
                8: { halign: "right" },
                9: { halign: "right" }
            },
            didDrawPage: (data) => {
                doc.setFontSize(7);
                doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
            }
        });

        doc.save("StatementofAccountsDetail.pdf");
    };

    useEffect(() => {
        if (!(reportType === "Summary" && custType === "customer")) {
            setChecked(false);
        }
    }, [reportType, custType]);

    useEffect(() => {
        if (reportType === "Summary") {
            setFileType("xlsx");
        }
    }, [reportType]);


    useEffect(() => {
        getCustStatementOfAccounts();
        getSupplierStatementOfAccounts();
        setshowdisable(true);
    }, []);

    return (
        <>
            {/* {loadingExcel ? (
                <Loader />
            ) : ( */}
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Statement Of Accounts</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end mb-2">
                            <div className="display-b me-2">
                                <Dropdown
                                    value={fileType}
                                    options={fileTypes}
                                    onChange={(e) => setFileType(e.value)}
                                    optionLabel="label"
                                    placeholder="Select"
                                    disabled={reportType === "Summary"}
                                />
                            </div>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={StatementOfAccountData}
                                disabled={loadingExcel}
                            >
                                {loadingExcel ? "Loading..." : "Download"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaDownload className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12 mb-3 pt-1">
                                <label className="form-label d-block">Type</label>
                                <div className="flex align-items-center d-inline me-3">
                                    <RadioButton
                                        inputId="ingredient1"
                                        name="customer"
                                        value="customer"
                                        onChange={handleCustType}
                                        checked={custType == "customer"}
                                    />
                                    <label htmlFor="ingredient1" className="ms-2">
                                        Customer
                                    </label>
                                </div>
                                <div className="flex align-items-center d-inline">
                                    <RadioButton
                                        inputId="ingredient1"
                                        name="Supplier"
                                        value="Supplier"
                                        onChange={handleCustType}
                                        checked={custType == "Supplier"}
                                    />
                                    <label htmlFor="ingredient1" className="ms-2">
                                        Supplier
                                    </label>
                                </div>
                            </div>
                            {/* =================================== */}
                            <div className="col-lg-9 col-md-6 col-sm-12 mb-3 pt-1 ps-0">
                                <label className="form-label d-block">Report Type</label>
                                <div className="flex align-items-center d-inline me-3">
                                    <RadioButton
                                        inputId="ingredient1"
                                        name="Summary"
                                        value="Summary"
                                        onChange={handleReportType}
                                        checked={reportType == "Summary"}
                                    />
                                    <label htmlFor="ingredient1" className="ms-2">
                                        Summary
                                    </label>
                                </div>
                                {/* ================= */}
                                {showdisable && (
                                    <>
                                        <div className="flex align-items-center d-inline me-4">
                                            <RadioButton
                                                inputId="ingredient1"
                                                name="Detail"
                                                value="Detail"
                                                onChange={handleReportType}
                                                checked={reportType == "Detail"}
                                            />
                                            <label htmlFor="ingredient1" className="ms-2">
                                                Detail
                                            </label>
                                        </div>
                                    </>
                                )}
                                <div className="d-inline-block flex align-items-center">
                                    <Checkbox
                                        inputId="expiredCustomers"
                                        onChange={(e) => {
                                            setFromDate(currentDate);
                                            setToDate(currentDate);
                                            setChecked(e.checked);
                                        }}
                                        checked={checked}
                                        disabled={!(reportType === "Summary" && custType === "customer")}
                                        className="me-2"
                                    />
                                    <label htmlFor="expiredCustomers" className="form-label mb-0">
                                        For Expired Customers
                                    </label>
                                </div>
                                {/* ======================= */}
                            </div>
                            {/* ======================= */}
                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    onChange={(e) => {
                                        setFromDate(e.target.value);
                                    }}
                                    showIcon
                                    value={fromDate}
                                    disabled={checked}
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar
                                    value={toDate}
                                    onChange={(e) => setToDate(e.value)}
                                    disabled={checked}
                                    showIcon
                                    min="2010-01-01"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                            {showdisable && (
                                <>
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <label className="form-label mb-2">Customer</label>
                                        <AutoComplete
                                            value={selectedCustomer}
                                            onChange={(e) => setSelectedCustomer(e.value)}
                                            suggestions={filteredcustAccountData}
                                            completeMethod={searchAccount}
                                            field="PARTY_NAME"
                                            dropdown
                                            placeholder="Search for a customer"
                                            className="w-100"
                                            disabled={
                                                custType !== "customer" || reportType !== "Detail"
                                            }
                                        />
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <label className="form-label mb-2">Supplier</label>
                                        <AutoComplete
                                            value={selectedSupplier}
                                            onChange={(e) => {
                                                setSelectedSupplier(e.value);
                                            }}
                                            suggestions={filteredSupplierAccountData}
                                            completeMethod={searchSupplier}
                                            field="SUPP_NAME"
                                            dropdown
                                            placeholder="Search for a supplier"
                                            className="w-100"
                                            disabled={
                                                custType !== "Supplier" || reportType !== "Detail"
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </section>

                {/* <section>
                    <div style={{ position: "relative", zIndex: "-999" }}>
                        <PDFExport
                            fileName="StatementofAccountsDetail.pdf"
                            paperSize="A4"
                            forcePageBreak=".page-break"
                            repeatHeaders={true}
                            multiPage={true}
                            scale={0.8}
                            ref={pdfExportComponent}
                        >
                            <div style={{ margin: "10px", fontSize: "12px" }}>
                                <div style={{ fontStyle: "italic", marginBottom: "10px" }}>
                                    <p>{auth.CompLongName}</p>
                                    <p>Report Name: <span>Statement of Accounts Detail</span></p>
                                    <p>Record Count: <span>{printData.length.toString()}</span></p>
                                    <p>From Date: <span>{format(new Date(fromDate), "dd/MM/yyyy")}</span></p>
                                    <p>To Date: <span>{format(new Date(toDate), "dd/MM/yyyy")}</span></p>
                                </div>

                                {reportType === "Detail" ? (
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr style={{ verticalAlign: "top", borderBottom: "1px solid #ccc" }}>
                                                <th>Document No.</th>
                                                <th>Document Date</th>
                                                <th>Document Type</th>
                                                <th>Due Date</th>
                                                <th>Reference Document No.</th>
                                                <th>Reference Document Date</th>
                                                <th>Mode</th>
                                                <th>Debit Amount</th>
                                                <th>Credit Amount</th>
                                                <th>Closing Balance</th>
                                                <th>Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {printData.map((data, i) => (
                                                <React.Fragment key={i}>
                                                    <tr>
                                                        <td>{data["Document No."]}</td>
                                                        <td>{data.Date}</td>
                                                        <td>{data["Document Type"]}</td>
                                                        <td>{data["Due date"]}</td>
                                                        <td>{data["Reference Document No."]}</td>
                                                        <td>{data["Reference Document Date"]}</td>
                                                        <td>{data?.Mode}</td>
                                                        <td>{data["Debit Amount"]}</td>
                                                        <td>{data["Credit Amount"]}</td>
                                                        <td>{data["Closing Balance"]}</td>
                                                        <td>{data.Type}</td>
                                                    </tr>
                                                    {(i + 1) % 30 === 0 && <tr className="page-break" />}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : reportType === "Summary" && custType === "Supplier" ? (
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th>Supplier Code</th>
                                                <th>Supplier Name</th>
                                                <th>Credit Limit</th>
                                                <th>Closing Balance</th>
                                                <th>Cheques in Hand</th>
                                                <th>Net Balance</th>
                                                <th>Debit or Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {printData.map((data, i) => (
                                                <React.Fragment key={i}>
                                                    <tr>
                                                        <td>{data["Supplier Code"]}</td>
                                                        <td>{data["Supplier Name"]}</td>
                                                        <td>{data["Credit Limit"]}</td>
                                                        <td>{data["Closing Balance"]}</td>
                                                        <td>{data["Cheques in Hand"]}</td>
                                                        <td>{data["Net Balance"]}</td>
                                                        <td>{data["Debit or Credit"]}</td>
                                                    </tr>
                                                    {(i + 1) % 30 === 0 && <tr className="page-break" />}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : reportType === "Summary" && custType === "customer" ? (
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th>Customer Code</th>
                                                <th>Customer Name</th>
                                                <th>Credit Limit</th>
                                                <th>Closing Balance</th>
                                                <th>Cheques in Hand</th>
                                                <th>Net Balance</th>
                                                <th>Debit or Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {printData.map((data, i) => (
                                                <React.Fragment key={i}>
                                                    <tr>
                                                        <td>{data["Customer Code"]}</td>
                                                        <td>{data["Customer Name"]}</td>
                                                        <td>{data["Credit Limit"]}</td>
                                                        <td>{data["Closing Balance"]}</td>
                                                        <td>{data["Cheques in Hand"]}</td>
                                                        <td>{data["Net Balance"]}</td>
                                                        <td>{data["Debit or Credit"]}</td>
                                                    </tr>
                                                    {(i + 1) % 30 === 0 && <tr className="page-break" />}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : null}
                            </div>
                        </PDFExport>

                    </div>
                </section> */}
            </div>
            {/* )} */}
        </>
    );
};

export default StatementOfAccounts;
